<template>
  <div class="space-y-4" @drop="$emit('drop', $event, type)" @dragover="$emit('dragover', $event, type)"
    @dragleave="$emit('dragleave', $event, type)" :class="{
      'bg-blue-50 border-2 border-blue-300 border-dashed rounded-lg':
        isDragOver,
    }">
    <!-- 컬럼 헤더 -->
    <div class="card-base p-3 text-center">
      <div class="font-medium text-gray-800 text-sm">
        {{ typeName }}
      </div>
      <div class="text-xs text-gray-500 mt-1">{{ bonds.length }}개 채권</div>
    </div>

    <!-- 채권 카드들 -->
    <div class="space-y-3 min-h-[200px]">
      <MsbBondCard v-for="bond in bonds" :key="bond.code" :bond="bond"
        :isDragged="draggedBond && draggedBond.code === bond.code" @dragstart="$emit('dragstart', $event, bond)"
        @dragend="$emit('dragend', $event)" @edit="$emit('edit', bond)" />

      <!-- 빈 상태 -->
      <div v-if="bonds.length === 0"
        class="text-center text-gray-400 text-sm py-8 border-2 border-dashed border-gray-200 rounded-lg bg-gray-50"
        :class="{ 'border-blue-300 bg-blue-50': isDragOver }">
        <i class="fas fa-plus-circle text-xl mb-2 opacity-50"></i>
        <div>데이터 없음</div>
      </div>
    </div>
  </div>
</template>

<script>
import MsbBondCard from './MsbBondCard.vue';

export default {
  name: 'MsbBondColumn',
  components: {
    MsbBondCard,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    typeName: {
      type: String,
      required: true,
    },
    bonds: {
      type: Array,
      default: () => [],
    },
    isDragOver: {
      type: Boolean,
      default: false,
    },
    draggedBond: {
      type: Object,
      default: null,
    },
  },
  emits: ['drop', 'dragover', 'dragleave', 'dragstart', 'dragend', 'edit'],
};
</script>

<style scoped>
/* 드래그 효과 */
.cursor-move {
  cursor: grab;
}

.cursor-move:active {
  cursor: grabbing;
}

/* 드래그 오버 효과 */
.drag-over {
  background-color: rgba(59, 130, 246, 0.05);
  border: 2px dashed #3b82f6;
}

/* 애니메이션 */
.transition-all {
  transition: all 0.2s ease-in-out;
}
</style>
